import React from 'react'
import NoContent from "./NoContent";
import HCLDX from "@system/config/hcldx";
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import HelperAnalyticsEvent from 'src/support/HelperAnalyticsEvent';
import AxiosIndicatorRunTimeLoader from '../AxiosIndicatorRunTimeLoader';

const Manufacturers = (props) => {
    const { manufacturerList, searchText, apiCall } = props;
    const [__check] = useAxiosIndicatorCheck();

    const typeHeadSearchEvent = (obj) => {
        HelperAnalyticsEvent.typeHeadSearchEvent(searchText, "Manufacturers", obj?.Name, (HCLDX.baseURL() + obj?.Url))
    }
    return (
        <>
            <div className="search-item-title text-uppercase">RECOMMENDED Manufacturers</div>
            {__check(['UNIVERSAL_SEARCH_DEDICATED_API_BULK_CALL']).status && !apiCall.Manufacturer ?
                <AxiosIndicatorRunTimeLoader />
                :
                <>
                    {Object.keys(manufacturerList).length > 0 ?
                        <>
                            <div className="search-product-list">
                                {Object.keys(manufacturerList).length > 0 && Object.entries(manufacturerList).map((v, i) => (
                                    <React.Fragment key={i}>
                                        {i < 5 &&
                                            <div className="search-product-list-item">
                                                <div className='search-product-list-item-info'>
                                                    <a onClick={() => typeHeadSearchEvent(v[1])} href={HCLDX.baseURL() + v[1].Url} className=" cursor-pointer" key={i}>
                                                        <div className="search-product-list-info-title">{v[1].Name}</div>
                                                    </a>
                                                    <div className="search-product-list-info-desc">{v[1].Description}</div>
                                                </div>
                                            </div>
                                        }
                                    </React.Fragment>
                                ))
                                }
                            </div>
                        </>
                        : <><NoContent /></>
                    }

                </>
            }

        </>
    )
}

export default Manufacturers